const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaModulo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PERFIL_ACESSO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'PERFIL_ACESSO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'PERFIL_ACESSO_MODULO_LISTADO':
            return {
				...state,
				listaModulo: action.payload.data
			};

        default:
            return state;
    }
}
